class ControlStateControlled {
  setValue<T>(stateFunction: React.Dispatch<React.SetStateAction<T>>, value: T,): void {
    stateFunction(value)
  }
}

export const controlStateControlled = new ControlStateControlled()